import {createLogger, createStore, Store, useStore as baseUseStore} from "vuex";
import {InjectionKey} from "vue";
import createPersistedState from "vuex-persistedstate";
import {CommonModuleState, CommonModule as common} from "@/store/modules/Common";
import {AuthModuleState, AuthModule as auth} from "@/store/modules/Auth";
import {HomeModuleState, HomeModule as home} from "@/store/modules/Home";
import {CmsModuleState, CmsModule as cms} from "@/store/modules/Cms";

export interface RootState {
  common: CommonModuleState;
  auth: AuthModuleState;
  home: HomeModuleState;
  cms: CmsModuleState;
}

export const key: InjectionKey<Store<RootState>> = Symbol();

export function useStore(): ReturnType<typeof baseUseStore> {
  return baseUseStore(key);
}

export default createStore({
  mutations: {},
  actions: {},
  modules: {common, auth, home, cms},
  plugins:
    // process.env.NODE_ENV === "development" ? [createLogger()] : undefined,
    process.env.NODE_ENV === "development" ? [createPersistedState({paths: ["auth", "cms.menuHide"]}), createLogger()] : [createPersistedState({paths: ["auth", "cms.menuHide"]})],
});
